import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import {
  Creators as IssuerActions,
  Types as IssuerTypes,
} from 'store/ducks/Issuer';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getList({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/issuers', {
      params: payload,
    });

    if (status === 200) {
      yield put(IssuerActions.getListIssuerSuccess(data));
    } else {
      Sentry.captureMessage('getList failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(IssuerActions.getListIssuerFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(IssuerActions.getListIssuerFail());
  }
}

function* deleteIssuer({ payload }) {
  try {
    const { status } = yield call(api.delete, `/issuers/${payload}`);
    if (status === 200) {
      yield put(IssuerActions.deleteIssuerSuccess());
    } else {
      Sentry.captureMessage('deleteIssuer failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(IssuerActions.deleteIssuerFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(IssuerActions.deleteIssuerFail());
  }
}

function* getIdIssuer({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/issuers/${payload}`);
    if (status === 200) {
      yield put(IssuerActions.getIdIssuerSuccess(data));
    } else {
      Sentry.captureMessage('getIdIssuer failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(IssuerActions.getIdIssuerFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(IssuerActions.getIdIssuerFail());
  }
}

function* createIssuer({ payload }) {
  try {
    const { status } = yield call(api.post, '/issuers', payload, {
      headers: {
        ...(payload instanceof FormData
          ? { 'Content-Type': 'multipart/form-data' }
          : {}),
      },
    });

    if (status === 200 || status === 204) {
      yield put(IssuerActions.createIssuerSuccess());
    } else {
      Sentry.captureMessage('createIssuer failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(IssuerActions.createIssuerFail());
    }

  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(IssuerActions.createIssuerFail());
  }
}

function* updateIssuer({ payload }) {
  try {
    const { status } = yield call(api.put, `/issuers/${payload.id}`, payload.data
    );
    if (status === 200) {
      yield put(IssuerActions.updateIssuerSuccess());
    } else {
      Sentry.captureMessage('updateIssuer failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(IssuerActions.updateIssuerFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(IssuerActions.updateIssuerFail());
  }
}

function* getListWatcher() {
  yield takeLatest(IssuerTypes.GET_LIST_ISSUER_REQUEST, getList);
}

function* deleteIssuerWatcher() {
  yield takeLatest(
    IssuerTypes.DELETE_ISSUER_REQUEST,
    deleteIssuer
  );
}

function* getIdIssuerWatcher() {
  yield takeLatest(
    IssuerTypes.GET_ID_ISSUER_REQUEST,
    getIdIssuer
  );
}

function* createIssuerWatcher() {
  yield takeLatest(
    IssuerTypes.CREATE_ISSUER_REQUEST,
    createIssuer
  );
}

function* updateIssuerWatcher() {
  yield takeLatest(
    IssuerTypes.UPDATE_ISSUER_REQUEST,
    updateIssuer
  );
}

export default function* rootSaga() {
  yield all([
    fork(getListWatcher),
    fork(deleteIssuerWatcher),
    fork(getIdIssuerWatcher),
    fork(createIssuerWatcher),
    fork(updateIssuerWatcher),
  ]);
}
